import { parseScbSlipQr } from '@pos/types';
import jsQR from 'jsqr';

export async function readSlipImage(
  file: File,
): Promise<{ qrPayload: string; imageBase64: string; contentType: string }> {
  if (
    !['image/png', 'image/jpeg'].includes(file.type) ||
    file.size > 2 * 1024 * 1024
  )
    throw new Error('กรุณาเลือกภาพ JPG หรือ PNG ขนาดไม่เกิน 2 MB');
  const image = await createImageBitmap(file);
  try {
    if (image.width * image.height > 16_000_000)
      throw new Error('ภาพมีขนาดใหญ่เกินไป กรุณาลดความละเอียด');
    const canvas = document.createElement('canvas');
    const scale = Math.min(1, 2400 / Math.max(image.width, image.height));
    canvas.width = Math.round(image.width * scale);
    canvas.height = Math.round(image.height * scale);
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) throw new Error('ไม่สามารถอ่านภาพได้');
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
    const qr = jsQR(pixels.data, pixels.width, pixels.height, {
      inversionAttempts: 'attemptBoth',
    });
    if (!qr || !parseScbSlipQr(qr.data))
      throw new Error('ไม่พบ Mini QR ของสลิป กรุณาใช้ภาพที่เห็น QR ชัดเจน');
    const imageBase64 = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('อ่านไฟล์สลิปไม่สำเร็จ'));
      reader.onload = () => resolve(String(reader.result).split(',')[1]!);
      reader.readAsDataURL(file);
    });
    return { qrPayload: qr.data, imageBase64, contentType: file.type };
  } finally {
    image.close();
  }
}
